<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.42331 1.68314C9.58787 1.94095 9.5794 2.27285 9.4019 2.52192C8.67814 3.53757 8.25001 4.77219 8.25001 6.11112C8.25001 9.53246 11.0231 12.3056 14.4445 12.3056C15.6282 12.3056 16.73 11.9686 17.6733 11.3897C17.9341 11.2296 18.266 11.2441 18.5119 11.4262C18.7578 11.6083 18.8684 11.9215 18.7914 12.2177C17.8069 16.0028 14.376 18.8056 10.2778 18.8056C5.41468 18.8056 1.47223 14.8631 1.47223 10C1.47223 5.69043 4.56796 2.11211 8.65348 1.34941C8.95414 1.29328 9.25875 1.42534 9.42331 1.68314ZM7.26513 3.34747C4.73348 4.49402 2.97223 7.04042 2.97223 10C2.97223 14.0347 6.24311 17.3056 10.2778 17.3056C13.0553 17.3056 15.4673 15.7518 16.7007 13.4653C15.988 13.6858 15.2308 13.8056 14.4445 13.8056C10.1947 13.8056 6.75001 10.3609 6.75001 6.11112C6.75001 5.13561 6.93323 4.20436 7.26513 3.34747Z"
            fill="currentColor"
        />
    </svg>
</template>
